export default __webpack_public_path__ + "images/a172a15357b8fcc077539406b86a73ea-science_small.webp";